module.exports = __webpack_public_path__ + "img/battery.28309078.svg";